<template>
  <div class="war-room-post-list-header">
    <WarRoomPostBreadcrumbs v-if="isBreadCrumbsVisible" class="war-room-post-list-header__breadcrumbs" />
    <nav v-if="!isBreadCrumbsVisible" class="war-room-post-list-header__tabs">
      <template v-for="{ name, key } in tabs">
        <NuxtLink
          v-if="!isActive(key)"
          :key="key"
          :to="{ path: `${$pages.WAR_ROOM_POSTS_TAB.path}/${key}` }"
          class="war-room-post-list-header__tab"
          data-test="posts_header_filter"
          @click.native="onTabClick(key)"
        >
          {{ name }}
        </NuxtLink>
        <h1
          v-else
          :key="key"
          class="war-room-post-list-header__tab war-room-post-list-header__tab--active"
          data-test="posts_header_filter"
        >
          {{ name }}
        </h1>
      </template>
    </nav>
  </div>
</template>

<script>
import WarRoomPostBreadcrumbs from '@/components/partials/war-room/WarRoomPostBreadcrumbs/WarRoomPostBreadcrumbs';
import { commonModalNames } from '@/components/common/constants';
import {
  myFeedTab,
  hotTab,
  newTab,
  TABS_QUERY_PARAM,
  DEFAULT_FEED_PATH,
} from '~/components/partials/war-room/constants';

export default {
  name: 'WarRoomPostListHeader',
  components: {
    WarRoomPostBreadcrumbs,
  },
  computed: {
    commonModalNames() {
      return commonModalNames;
    },
    rootPath() {
      return DEFAULT_FEED_PATH;
    },
    defaultFeedTab() {
      return {
        ...myFeedTab,
        name: this.$auth.loggedIn ? myFeedTab.name : myFeedTab.nameAnonymous,
      };
    },
    tabs() {
      return [
        {
          name: this.defaultFeedTab.name,
          key: this.defaultFeedTab.key,
          isActive: !this.activeTabKey || this.activeTabKey === this.defaultFeedTab.key,
        },
        {
          name: hotTab.name,
          key: hotTab.key,
          isActive: this.activeTabKey === hotTab.key,
        },
        {
          name: newTab.name,
          key: newTab.key,
          isActive: this.activeTabKey === newTab.key,
        },
      ];
    },
    activeTabKey() {
      return this.$route.params[TABS_QUERY_PARAM];
    },
    isBreadCrumbsVisible() {
      return ['war-room-topics-topicSlug-posts', 'war-room-categories-categorySlug-posts'].includes(this.$route.name);
    },
  },
  methods: {
    onTabClick(tabKey = this.defaultFeedTab.key) {
      this.$analytics.logEvent('war-room__sorting-button__click', {
        sortingName: tabKey,
      });
    },
    isActive(tabKey) {
      return `${this.$pages.WAR_ROOM_POSTS_TAB.path}/${tabKey}` === this.$route.path;
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-post-list-header {
  @include mq('sm') {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__breadcrumbs {
    margin: 0 16px;

    @include mq('sm') {
      margin: 0 0 12px;
    }
  }

  &__tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }

  &__tab {
    @include subhead-semibold;

    margin: 0;
    color: var(--gray-50);
    text-decoration: none;
    line-height: inherit;
    -webkit-tap-highlight-color: transparent;

    & + & {
      margin-left: 12px;
    }

    &--active {
      color: var(--theme-color-sub-text);
    }
  }
}
</style>
